<template>
  <MpModal class="modal-tool" v-if="isShow">
    <div class="learning-state-editor">
      <button class="close" @click="doClose">閉じる</button>
      <ul class="tab-nav">
        <li :class="{ selecting: tabIndex === 0 }" @click="tabIndex = 0">学習状況</li>
        <li :class="{ selecting: tabIndex === 1 }" @click="tabIndex = 1">エラー</li>
        <li :class="{ selecting: tabIndex === 2 }" @click="tabIndex = 2">操作</li>
      </ul>
      <div class="tab-content">
        <div v-if="tabIndex === 0">
          <button @click="doInit">初期化</button>
          <button @click="doRefresh">最新</button>
          <button @click="changeAllClear()">全クリア</button>
          <button @click="doUpdate">変更</button>
          <button @click="doSend">送信</button>
          <textarea class="editor" v-model="learningState"></textarea>
        </div>
        <div v-else-if="tabIndex === 1" class="error">
          <ul class="error-list">
            <li v-for="(e, i) in latestErrors" class="error-item" :key="i">
              <div class="info">
                <div class="datetime">{{ e.datetime }}</div>
                <div class="view">{{ e.view }}</div>
                <div v-if="source(e)" class="source">{{ source(e) }}</div>
              </div>
              <div class="error-message">{{ e.message }}</div>
              <details v-if="e.stack" class="stack">
                <summary>{{ summary(e.stack) }}</summary>
                <pre>{{ e.stack }}</pre>
              </details>
            </li>
          </ul>
        </div>
        <div v-else-if="tabIndex === 2">
          <ul class="control-list">
            <li>
              <button @click="occurError()">エラーを発生させる</button>
            </li>
            <li>
              <button @click="startRestrictionDeliberately()">使用制限</button>
              <input v-model="restrictionDelay" type="number" name="restrictionDelay" id="">
            </li>
          </ul>
        </div>
      </div>
    </div>
  </MpModal>
</template>

<script>
import MpModal from "@/components/ui/MpModal.vue";
import { mapState } from "vuex";
import Restriction from "@/mixins/restriction";

export default {
  components: {
    MpModal,
  },
  mixins: [Restriction],
  data: function () {
    return {
      tabIndex: 0,
      learningState: {},
      restrictionDelay: 0,
    };
  },
  computed: {
    isShow: function () {
      return this.$store.getters["app/isShowLearningStateEditor"];
    },
    ...mapState({
      errors: (state) => state.app.errors,
    }),
    latestErrors: function () {
      return this.errors.toReversed();
    },
  },
  mounted() {
    this.learningState = JSON.stringify(
      this.$store.getters["learningState/getState"]
    );
  },
  methods: {
    doInit() {
      this.learningState = JSON.stringify(
        this.$store.getters["learningState/getDefaultState"]
      );
    },
    doUpdate() {
      var newState = JSON.parse(this.learningState);
      this.$store.commit("learningState/copy", newState);
    },
    doRefresh() {
      const state = this.$store.getters["learningState/getState"];
      this.learningState = JSON.stringify(state);
    },
    changeAllClear() {
      const state = JSON.parse(JSON.stringify(
        this.$store.getters["learningState/getState"]
      ));

      state.answered = 9999;

      for (let stage of ['normal', 'bonus']) {
        for (let table in state[stage]) {
          for (let level in state[stage][table]) {
            if (level === 'conversation') continue;

            state[stage][table][level] = {
              challenge: 3,
              clear: 3,
              time: 0,
              results: [],
            };
          }
        }
      }

      this.learningState = JSON.stringify(state);
    },
    doSend() {
      this.$store.dispatch("learningState/post");
    },
    occurError() {
      setTimeout(() => {
        this.someThing.what;
      }, 100);
      setTimeout(async () => {
        this.someThing.what;
      }, 100);
      this.someThing.what;
    },
    doClose() {
      this.$store.commit("app/setShowLearningStateEditor", false);
    },
    summary(stack) {
      return stack.split('\n')[0];
    },
    source(error) {
      if (error.from === "errorHandler") {
        const name = error.vm.$options.name || error.vm.$options._componentTag;
        return `<${name} />`;
      }
      if (error.from === "window.onerror") {
        const name = this.findComponentName(error.filename);
        return name ? `<${name} />` : "";
      }
      if (error.from === "window.onunhandledrejection") {
        const name = this.findComponentName(error.stack);
        return name ? `<${name} />` : "";
      }

      return "";
    },
    findComponentName(string) {
      return string.match(/\/([^/]+)\.vue/)?.[1] ?? "";
    },
    startRestrictionDeliberately() {
      setTimeout(() => {
        this.startRestriction();
      }, this.restrictionDelay * 1000);
    }
  },
};
</script>

<style lang="scss" scoped>
.learning-state-editor {
  height: 100%;
  .close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0.5% 1%;
  }
  .tab-nav {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      flex: 1;
      text-align: center;
      padding: 10px;
      cursor: pointer;
      background-color: #f0f0f0;
      border: 1px solid #ccc;
      border-bottom: none;
      &.selecting {
        background-color: #fff;
      }
      &:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
  .tab-content {
    border: 1px solid #ccc;
    border-top: none;
    padding: 10px;

    height: 90%;

    .error {
      height: 100%;
      .error-list {
        list-style: none;
        padding: 0;
        margin: 0;
        height: 100%;
        overflow-y: scroll;
        .error-item {
          user-select: text;
          border: 1px solid #ccc;
          margin-bottom: 5px;
          padding: 5px;
          .info {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.5rem;

            .datetime {
              font-size: 0.8em;
              color: #666;
            }
            .view {
              font-size: 0.8em;
              color: #666;
            }
            .source {
              font-size: 0.8em;
              color: #666;
            }
          }

          .error-message {
            font-weight: bold;
            background-color: #FCEBEB;
          }
          .stack {
            padding-top: 0.5rem;
            font-size: 0.8em;
            background-color: #FCEBEB;
            color: #444;
          }
        }
      }
    }
  }
  .editor {
    width: 100%;
    height: 300px;
  }
  button {
    margin: 5px;
  }
}
</style>